import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromThirdPartyPayroll from './third-party-payroll.reducer';
import { ReimbursementPaycode } from './reimbursement-paycode.model';

export const selectThirdPartyPayrollState =
    createFeatureSelector<fromThirdPartyPayroll.State>(
        fromThirdPartyPayroll.thirdPartyPayrollFeatureKey
    );

export const { selectIds, selectEntities, selectAll, selectTotal } =
    fromThirdPartyPayroll.adapter.getSelectors(selectThirdPartyPayrollState);

export const selectPayrollCodes = createSelector(
    selectThirdPartyPayrollState,
    (state: fromThirdPartyPayroll.State) =>
        [...state.payrollCodes].sort((a, b) =>
            a.Paycode.localeCompare(b.Paycode)
        )
);
export const selectFileFormats = createSelector(
    selectThirdPartyPayrollState,
    (state: fromThirdPartyPayroll.State) => state.fileFormats
);
export const selectReimbursementPaycodes = createSelector(
    selectThirdPartyPayrollState,
    (state: fromThirdPartyPayroll.State): ReimbursementPaycode[] =>
        state.reimbursementPaycodes
);
